import React from 'react';
import './About.css';
import { Card, CardGroup } from 'react-bootstrap';
import Iframe from 'react-iframe';
import Menu from '../Menu/Menu';
import t1 from '../../img/t1.PNG';
import t2 from '../../img/t2.PNG';
import t3 from '../../img/t3.PNG';
import history from '../../img/History-of-Company (1).png';
import emp from '../../img/5236.jpg'


const About = () => {
    return (
        <div>
            
            <div className='about'>
            <div className='bg'>
                <Menu></Menu>
                <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>About Us</h1>
            </div>
        </div>
            <h2 className='heading pt-5 px-3'>Company Profile of PROPER Design & Development Limited</h2>
            <hr className='w-75 mx-auto'></hr>
            <h5 className='px-lg-5 mx-lg-5 padding-left'>
            <strong>PROPER Design & Development Limited</strong> is well known and excellence work holder about civil engineering Sector in Bangladesh. Our company offers a breadth of multi-discipline professional services that accounts for design, engineering, procurement and support services for all facets of industry. Specially we are conducts Land Survey and soil test(Field test & laboratory test) all over Bangladesh publicly and Privately. We prominence on safety, creativity and sustainability in our regular performance to cultivate design excellence and setting a high standard in meeting customer expectations. <br></br><br></br>
            </h5>
            <div className='row px-lg-5 mx-lg-5'>
                <div className='col-lg-6 col-sm-12'>
                    <h5>
                        <h4 className='text-decoration-underline fw-bold'>Internal information:</h4>
                        <strong>
                            <span style={{"color": "rgb(55, 165, 150)"}}>Official name: PROPER Design & Development Limited</span>
                        </strong> <br></br>
                        <strong>Documents:</strong> <br></br>
                        Trade License No. : <br></br>
                        TIN NO.: <br></br>
                        BIN NO.: <br></br>
                        Licensed by: Dhaka North City Corporation (DNCC) <br></br>
                        Bank Transaction with: Social Islami Bank Ltd, Begum Rokeya Sharani Branch, Dhaka <br></br>
                        <strong>Current Staff Strength:</strong> <br></br>
                        Consultants and Professionals: 15 Person <br></br>
                        Technicians and Sub-professionals: 20 Persons <br></br>
                        Other (Admin and Supporting): 15 Persons
                    </h5>
                </div>
                <div className='col-lg-6 col-sm-12'>
                    <img src={emp} alt="" width="100%" className='mt-lg-5 pt-5'/>
                </div>
            </div>
            
            <h2 className='heading pt-5'>History of Company</h2>
            <hr className='w-25 mx-auto'></hr>
            <div className='row'>
                <div className='col-lg-7 col-sm-12'>
                    <h5 className='ps-lg-5 ms-lg-5 padding-left mt-5'>
                        <strong>PROPER Design & Development Limited</strong> is an independent, multidisciplinary
                        Survey and design based organization in Bangladesh. This company was
                        founded in 2018 as a single ownership entity. Firstly it was starts only soil testing
                        and civil engineering based survey, but since 2020 our company also serves
                        as design analysis of building structures with clients priority.
                    </h5>
                </div>
                <div className='col-lg-5 col-sm-12'>
                    <img src={history} alt="" width="60%"/>
                </div>
            </div>

            <h2 className='heading pt-5'>Health and Safety</h2>
            <hr className='w-25 mx-auto'></hr>
            <h5 className='px-lg-5 mx-lg-5 padding-left'>
            We ensure that all safety and health Care which direction provided by BNBC.
            </h5>

                    <div className='px-lg-5 mx-lg-5 padding-left'>
                        <h2 className='heading pt-5'>Why Choose Us</h2>
                        <hr className='w-25 mx-auto'></hr>
                        <h5 className='padding-left'>
                            &#10004; We ensure our best quality within cost effective and timely execution. <br></br>
                            &#10004; We have highly experienced consultants & quality performances
professionals and sub-professionals. <br></br>
                            &#10004; Communication is most important skill in technical section, we ensure this
property appropriately. <br></br>
                            &#10004; We are committed to fill-up our honorable clients demands. <br></br>
                            &#10004; We provide our project to clients at due time. <br></br>
                            &#10004; We have enough technical and laboratory equipment. <br></br>

                            <h4 className='text-decoration-underline fw-bold pt-3'>List of our Survey equipment :</h4>
                            <img src={t1} alt=""/>

                            <h4 className='text-decoration-underline fw-bold pt-4'>List of our Soil test equipment (Field) :</h4>
                            <img src={t2} alt=""/>

                            <h4 className='text-decoration-underline fw-bold pt-4'>List of our Soil test equipment (Field) :</h4>
                            <img src={t3} alt="" className='mb-5'/>

                        </h5>
                    </div>
        </div>
    );
};

export default About;